import i18n from 'i18next';
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en_t from 'utils/i18n/translations/en';
import de_t from 'utils/i18n/translations/de';
import fr_t from 'utils/i18n/translations/fr';
import it_t from 'utils/i18n/translations/it';
import de_t_gba from 'utils/i18n/translations/de_customer-gba';

import en_f from 'utils/i18n/formats/en';
import en_US_f from 'utils/i18n/formats/en-US';
import de_f from 'utils/i18n/formats/de';
import fr_f from 'utils/i18n/formats/fr';
import it_f from 'utils/i18n/formats/it';

import date_en from 'date-fns/locale/en-US';
import date_de from 'date-fns/locale/de';
import date_fr from 'date-fns/locale/fr';
import date_it from 'date-fns/locale/it';

export const getDateLocale = () => {
  const lng = getI18nLng();

  switch (lng) {
    case 'de':
      return date_de;
    case 'fr':
      return date_fr;
    case 'it':
      return date_it;
    default:
      return date_en;
  }
};

const options = {
  // order and from where user language should be detected
  order: ['localStorage', 'sessionStorage', 'navigator'],
  lookupLocalStorage: 'ct-web-lng',
  lookupSessionStorage: 'ct-web-lng',
  caches: ['localStorage'],
  excludeCacheFor: ['cimode'], // languages to not persist (cookie, localStorage)
};

const resources = {
  en: {
    translations: en_t,
    formats: en_f,
  },
  'en-US': {
    translations: en_t,
    formats: en_US_f,
  },
  de: {
    translations: de_t,
    formats: de_f,
  },
  'de-DE': {
    translations: de_t,
    formats: de_f,
  },
  // Customer: GBA translation, only german
  // lng format is "<locale>_Customer"
  de_gba: {
    translations: de_t_gba,
    formats: de_f,
  },
  fr: {
    translations: fr_t,
    formats: fr_f,
  },
  'fr-FR': {
    translations: fr_t,
    formats: fr_f,
  },
  it: {
    translations: it_t,
    formats: it_f,
  },
  'it-IT': {
    translations: it_t,
    formats: it_f,
  },
};
const supportedLanguages = Object.keys(resources);

i18n
  .use(new LanguageDetector(null, options))
  .use(initReactI18next)
  .init({
    resources: resources,
    fallbackLng: 'en',
    debug: false,
    // have a common namespace used around the full app
    ns: ['translations', 'formats'],
    defaultNS: 'translations',
    keySeparator: false, // we use content as keys
    cleanCode: true,
    interpolation: {
      escapeValue: false, // not needed for react!!
      formatSeparator: ',',
    },
    react: {
      wait: true,
    },
  });

export { i18n, supportedLanguages };
export const getI18nLng = () => i18next.language.slice(0, 2);
export const getBrowserLng = () => window.navigator.language.slice(0, 2);

export const translateForCustomer = (key, customer, options = {}) => {
  if (customer && customer.lngPostfix) {
    return i18n.t(key, { ...options, lng: `${getI18nLng()}${customer.lngPostfix}` });
  }

  return i18n.t(key, options);
};
